import api, { unwrap } from './client';

export async function listPackages(params = {}) {
  return unwrap(await api.get('/packages', { params }));
}

export async function getPackage(id) {
  return unwrap(await api.get(`/packages/${id}`));
}

export async function createPackage(payload) {
  return unwrap(await api.post('/packages', payload));
}

export async function updatePackage(id, payload) {
  return unwrap(await api.put(`/packages/${id}`, payload));
}

export async function deletePackage(id) {
  return unwrap(await api.delete(`/packages/${id}`));
}

export async function uploadPackageBanner(id, file) {
  const fd = new FormData();
  fd.append('file', file);
  return unwrap(
    await api.post(`/packages/${id}/banner`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  );
}

export async function deletePackageBanner(id) {
  return unwrap(await api.delete(`/packages/${id}/banner`));
}

export function packageBannerUrl(pkg) {
  if (!pkg?.bannerUrl) return '';
  const base = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api/v1').replace(/\/api\/v1\/?$/, '');
  return `${base}${pkg.bannerUrl}?v=${pkg.updatedAt || ''}`;
}
